<template>
	<div class="main-content" :style='{"color":"#666","padding":"20px 30px 30px","fontSize":"16px"}'>
		<!-- 列表页 -->
		<template v-if="showFlag">
			<el-form class="center-form-pv" :style='{"margin":"0 0 20px","fontSize":"inherit"}' :inline="true" :model="searchForm">
				<el-row :style='{"fontSize":"inherit","display":"block"}' >
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">标题</label>
						<el-input v-model="searchForm.title" placeholder="标题" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">分类</label>
						<el-select v-model="searchForm.categoryId" placeholder="请选择分类" clearable>
							<el-option v-for="item in categoryList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
						</el-select>
					</div>
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">状态</label>
						<el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
							<el-option label="草稿" :value="0"></el-option>
							<el-option label="已发布" :value="1"></el-option>
						</el-select>
					</div>
					<el-button class="search" type="success" @click="search()">
						<span class="icon iconfont icon-yanziwancheng" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						搜索
					</el-button>
				</el-row>

				<el-row class="actions" :style='{"flexWrap":"wrap","margin":"20px 0","display":"flex"}'>
					<el-button class="add" v-if="isAuth('article','新增')" type="success" @click="addOrUpdateHandler()">
						<span class="icon iconfont icon-kaitongfuwu" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						新增
					</el-button>
					<el-button class="del" v-if="isAuth('article','删除')" :disabled="dataListSelections.length?false:true" type="danger" @click="deleteHandler()">
						<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						删除
					</el-button>
				</el-row>
			</el-form>
			<div :style='{"width":"100%","padding":"0","background":"none"}'>
				<el-table class="tables"
					:stripe='false'
					:style='{"padding":"0","borderColor":"#eee","color":"inherit","borderWidth":"1px 0 0 1px","background":"#fff","width":"100%","fontSize":"inherit","borderStyle":"solid"}' 
					:border='true'
					v-if="isAuth('article','查看')"
					:data="dataList"
					v-loading="dataListLoading"
				@selection-change="selectionChangeHandler">
					<el-table-column :resizable='true' type="selection" align="center" width="50"></el-table-column>
					<el-table-column :resizable='true' :sortable='true' label="序号" type="index" width="50" />
					<el-table-column :resizable='true' :sortable='true'  
						prop="title"
						label="标题">
						<template slot-scope="scope">
							{{scope.row.title}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="categoryName"
						label="分类">
						<template slot-scope="scope">
							<el-tag type="primary">{{scope.row.categoryName}}</el-tag>
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="author"
						label="作者">
						<template slot-scope="scope">
							{{scope.row.author}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="publishTime"
						label="发布时间">
						<template slot-scope="scope">
							{{scope.row.publishTime}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true' prop="coverImage" width="120" label="封面">
						<template slot-scope="scope">
							<div v-if="scope.row.coverImage">
								<img v-if="scope.row.coverImage.substring(0,4)=='http'" :src="scope.row.coverImage.split(',')[0]" width="80" height="80">
								<img v-else :src="$base.url+scope.row.coverImage.split(',')[0]" width="80" height="80">
							</div>
							<div v-else>无图片</div>
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="viewCount"
						width="100"
						label="浏览量">
						<template slot-scope="scope">
							{{scope.row.viewCount}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="isTop"
						width="80"
						label="置顶">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.isTop==1" type="warning">是</el-tag>
							<el-tag v-else type="info">否</el-tag>
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="isRecommend"
						width="80"
						label="推荐">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.isRecommend==1" type="success">是</el-tag>
							<el-tag v-else type="info">否</el-tag>
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="status"
						width="100"
						label="状态">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.status==1" type="success">已发布</el-tag>
							<el-tag v-else type="warning">草稿</el-tag>
						</template>
					</el-table-column>
					<el-table-column :resizable='true' width="280" label="小程序路径">
						<template slot-scope="scope">
							<div style="display: flex; align-items: center;">
								<el-input 
									:value="`/pages/article/detail?id=${scope.row.id}`" 
									size="small"
									readonly
									style="flex: 1; margin-right: 5px;">
								</el-input>
								<el-button 
									size="mini" 
									type="primary" 
									icon="el-icon-document-copy"
									@click="copyPath(`/pages/article/detail?id=${scope.row.id}`)">
									复制
								</el-button>
							</div>
						</template>
					</el-table-column>
					<el-table-column width="300" label="操作">
						<template slot-scope="scope">
							<el-button class="view" v-if=" isAuth('article','查看')" type="success" @click="addOrUpdateHandler(scope.row.id,'info')">
								<span class="icon iconfont icon-dagou" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								查看
							</el-button>
							<el-button class="edit" v-if=" isAuth('article','修改') " type="success" @click="addOrUpdateHandler(scope.row.id)">
								<span class="icon iconfont icon-bianji" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								修改
							</el-button>
							<el-button class="del" v-if="isAuth('article','删除') " type="primary" @click="deleteHandler(scope.row.id )">
								<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		<el-pagination
			@size-change="sizeChangeHandle"
			@current-change="currentChangeHandle"
			:current-page="pageIndex"
			background
			:page-sizes="[10, 20, 30, 50]"
			:page-size="pageSize"
			:layout="layouts.join()"
			:total="totalPage"
			prev-text="上一页 "
			next-text="下一页 "
			:hide-on-single-page="false"
			:style='{"padding":"0","margin":"20px 0 0","whiteSpace":"nowrap","color":"inherit","width":"100%","fontSize":"inherit","fontWeight":"500"}'>
		</el-pagination>
		</template>
		<!-- 添加/修改页面  -->
		<add-or-update v-if="!showFlag" :parent="this" ref="addOrUpdate"></add-or-update>
	</div>
</template>
<script>
import AddOrUpdate from "./add-or-update";
export default {
  data() {
    return {
      searchForm: {
        title: '',
        categoryId: '',
        status: ''
      },
      dataList: [],
      categoryList: [],
      dataListSelections: [],
      showFlag: true,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      layouts: ["total","prev","pager","next","sizes","jumper"]
    };
  },
  components: {
    AddOrUpdate
  },
  mounted() {
    this.getCategoryList();
    this.search();
  },
  activated() {
    this.getCategoryList();
    this.search();
  },
  methods: {
    // 复制路径
    copyPath(path) {
      const input = document.createElement('input');
      input.value = path;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$message.success('路径已复制到剪贴板');
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
      }
      document.body.removeChild(input);
    },
    // 获取分类列表
    getCategoryList() {
      this.$http({
        url: "articleCategory/list",
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.categoryList = data.data;
        }
      });
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'id',
        order: 'desc'
      };
      if (this.searchForm.title) {
        params["title"] = `%${this.searchForm.title}%`;
      }
      if (this.searchForm.categoryId) {
        params["categoryId"] = this.searchForm.categoryId;
      }
      if (this.searchForm.status !== '' && this.searchForm.status !== undefined) {
        params["status"] = this.searchForm.status;
      }
      this.$http({
        url: "article/page",
        method: "get",
        params: params
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.totalPage = data.data.total;  // 修改为total，与后端返回字段一致
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id, type) {
      this.showFlag = false;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, type);
      });
    },
    // 删除
    deleteHandler(id) {
      var ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => {
            return Number(item.id);
          });
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "article/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500
            });
            this.search();
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>

/* 覆盖Element UI的success绿色为青蓝色 #56B2C6 */
.el-button--success {
    background-color: #56B2C6 !important;
    border-color: #56B2C6 !important;
}

.el-button--success:hover,
.el-button--success:focus {
    background-color: #68bdd2 !important;
    border-color: #68bdd2 !important;
}

.el-tag--success {
    background-color: rgba(86,178,198,.1) !important;
    border-color: rgba(86,178,198,.2) !important;
    color: #56B2C6 !important;
}

/* 增加表格行高，让按钮不拥挤 */
::v-deep .el-table__row {
    height: 70px;
}

::v-deep .el-table td.el-table__cell {
    padding: 16px 0;
}

::v-deep .el-table__body td.el-table__cell .cell {
    line-height: 38px;
}

/* 调整操作列按钮间距 */
::v-deep .el-table__body td.el-table__cell .el-button {
    margin: 4px 3px;
}

</style>

